import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Hourglass, CheckCircle2, Clock, MessageCircle } from 'lucide-react';
export function VerificationPendingScreen() {
  const navigate = useNavigate();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="flex flex-col items-center justify-center min-h-screen bg-slate-50 p-6 text-center" data-id="element-1745">
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="w-24 h-24 bg-amber-100 rounded-full flex items-center justify-center mb-6 relative" data-id="element-1746">
        <Hourglass className="w-12 h-12 text-amber-600" data-id="element-1747" />
        <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-1748">
          <Clock className="w-5 h-5 text-amber-500" data-id="element-1749" />
        </div>
      </motion.div>

      <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1750">
        Profile Under Review
      </h1>
      <p className="text-slate-500 mb-8 max-w-[280px]" data-id="element-1751">
        We are currently verifying your credentials. This usually takes 24-48
        hours.
      </p>

      <div className="bg-white w-full p-5 rounded-2xl shadow-sm border border-slate-100 mb-8 text-left" data-id="element-1752">
        <h3 className="font-semibold text-slate-900 mb-4" data-id="element-1753">
          Verification Checklist
        </h3>
        <div className="space-y-4" data-id="element-1754">
          <div className="flex items-center gap-3" data-id="element-1755">
            <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-1756" />
            <span className="text-sm text-slate-700" data-id="element-1757">Profile Information</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-1758">
            <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-1759" />
            <span className="text-sm text-slate-700" data-id="element-1760">Government ID</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-1761">
            <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" data-id="element-1762" />
            <span className="text-sm text-slate-700" data-id="element-1763">Medical License</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-1764">
            <Clock className="w-5 h-5 text-amber-500 shrink-0" data-id="element-1765" />
            <span className="text-sm text-slate-700 font-medium" data-id="element-1766">
              Background Check (Pending)
            </span>
          </div>
        </div>
      </div>

      <div className="w-full space-y-3" data-id="element-1767">
        <button onClick={() => navigate('/provider/dashboard')} className="w-full bg-blue-600 text-white py-3.5 rounded-xl font-semibold text-lg shadow-sm hover:bg-blue-700 transition-colors" data-id="element-1768">
          Preview Dashboard
        </button>
        <button className="w-full bg-white text-slate-700 py-3.5 rounded-xl font-semibold shadow-sm border border-slate-200 hover:bg-slate-50 transition-colors flex items-center justify-center gap-2" data-id="element-1769">
          <MessageCircle className="w-5 h-5" data-id="element-1770" />
          Contact Support
        </button>
      </div>
    </motion.div>;
}